export default __webpack_public_path__ + "static/news3-a5e193a3aad7505088b421d0a8d64161.png";